// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorPopup_root__ZBX2I","content":"ErrorPopup_content__8TQNv","icon":"ErrorPopup_icon__81qeI","text":"ErrorPopup_text__x_vMN","btn":"ErrorPopup_btn__FVftd"};